<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="textno" style="text-align:center;"> </p>
<p class="textno" style="text-align:center;"> </p>
<p class="textno" style="text-align:center;"> </p>
<p class="textno" style="text-align:center;"><span class="bold">Most of this book is for Jim Kravets, whose thirst for life matches mine, and whose faith in my talent has always exceeded mine.</span></p>
<p class="textno" style="text-align:center;"><span class="bold">Except for the callipygian strips. Those are obviously for Patty.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frazz-006.vue?08cca2a7